import { Dialog, DialogFooter } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { FormSpinner } from "../../../../components/FormSpinner";
import { StyledPrimaryButton } from "../../../../components/styled";
import { useSelector } from "../../../../store/hooks";
import {
  deleteAssessmentRoutine,
  setDeleteAssessmentDialog,
} from "../../../../store/recommendationPage";

export const DeleteAssessmentDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { assessment } = useSelector(
    (s) => s.recommendationPage.deleteAssessmentDialog
  );
  const isLoading = useSelector(
    (s) => s.recommendationPage.deleteAssessmentLoadStatus === "loading"
  );

  const close = () => {
    dispatch(
      setDeleteAssessmentDialog({
        assessment: null,
        isOpen: false,
      })
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: t("greco.areYouSure"),
      }}
      onDismiss={close}
    >
      {t("greco.deletingIsPermanent")}
      <DialogFooter>
        <StyledPrimaryButton
          text={t("greco.delete")}
          onClick={() => {
            dispatch(
              deleteAssessmentRoutine.trigger({
                locationId: assessment.locationId,
                reportId: assessment.reportId,
                recommendationId: assessment.recommendationId,
                assessmentId: assessment.assessmentId,
              })
            );
          }}
          disabled={isLoading}
        />
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
